<div class="layout" *ngIf="noHeaderFooterMode">
    <app-header [isDefaultHeaderMode]="defaultHeaderMode"></app-header>
    <app-nav-bar *ngIf="defaultHeaderMode"></app-nav-bar>
    <router-outlet></router-outlet>
    <app-footer *ngIf="defaultHeaderMode && !noFooterMode"></app-footer>
</div>
<div *ngIf="!noHeaderFooterMode">
    <router-outlet></router-outlet>
</div>
<ng-template #timeoutModal>
    <div class="bgCover"></div>
    <div id="sessionPopUp">
        <a href="javascript:void(0);"><span class="sessionButClose" (click)="extendSession()"></span></a>
          <div id="pop_header">
          <h3>{{content.SESSION_TIMEOUT_TITLE}}</h3> 
          </div>
          <div class="confPopup">
              <span id="timeDisplay">{{currentIdleTime}}</span><p>{{content.SESSION_TIMEOUT_CONTENT}}</p>
              <p>{{content.SESSION_TIMEOUT_SUB_CONTENT}}</p>
          </div>
          <div class="okBtn">
                <img src="assets/images/BTN_SECONDARY_OK.png" alt="ok" class="button" (click)="extendSession()">
         </div>
    </div>
</ng-template>